import { useQuery as usePromoBannerQuery } from "@faire/web-api/api/messaging/promo_banner/get-hooks";
import { useEffect } from "react";

import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { usePromoBannerStore } from "@faire/retailer/stores/ui/PromoBannerStore";

// For the purpose of prefetching
export const useInProductBannersSetup = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { setInProductMessagingBanners } = usePromoBannerStore([
    "setInProductMessagingBanners",
  ]);

  const { data } = usePromoBannerQuery(undefined, {
    enabled: isLoggedInRetailer,
  });

  useEffect(() => {
    if (data?.banner_messages?.length) {
      // set this in the promobanner store so it knows to render FaireValuesBanner, which
      // is where the inProductBanners are rendered for now until complete migration
      setInProductMessagingBanners(data.banner_messages);
    }
  }, [data, setInProductMessagingBanners]);
};
